import { OpenType } from "@q/softCore";
export interface IRes {
  errno?: number;
  errmsg?: string;
  data?: any;
  [propName: string]: any;
}

export interface IAction {
  type: string;
  [propName: string]: any;
}

export enum ITag {
  "new" = 1,
  "recommend" = 2,
  "hot" = 3,
}

export const ICategorys = {
  "1": "运营",
  "2": "CPT",
  "3": "CPS/CPA",
};
export interface ISoftConfig {
  open_type?: OpenType;
  href?: string;
  exec?: string;
  open_first?: "0" | "1";
  btn_text?: string;
  ads?: IAds;
  category?: "1" | "2" | "3";
  progressName?: string;
}

export interface IAds {
  imptk: string[];
  clktk: string[];
}

export interface ISoftData extends ISoftConfig {
  soft_id: number; // soft_id 服务端传递的值实际上是string类型，但是在数据库和客户端都是number类型，所以在无须对soft_id做任何处理的情况下，此处定义的类型是number
  name: string;
  desc?: string;
  icon?: string;
  url?: string;
  downloadnum?: string;
  size?: string | number;
  tag?: ITag;
  ads?: IAds;
  // opentype?: OpenType;
  [propName: string]: any;
}

export interface ISoftTab {
  title: string;
  data: ISoftData[];
}

export interface IAdData extends ISoftConfig {
  soft_id: number;
  ad_id: string;
  url: string;
  name: string;
  clktk?: string[];
  imptk?: string[];
  startTime?: string;
  endTime?: string;
  isCom?: boolean;
  instsoftid?: string; // 判断是否安装软件的softid，多个以|分割
  countdown?: number; // 是否显示倒计时 1: 显示5秒倒计时 0: 显示关闭
  // category?: string; // 区分是否是cpt广告 1: cpt
}

export interface IIndexData {
  top: ISoftData[];
  new_top: ISoftData[];
  banner: ISoftData[];
  soft: ISoftTab[];
  special1: ISoftData[];
  special2: ISoftData[];
  recent: ISoftData[];
  ad: IAdData[];
  soft_id_list: string[];
  searches: ISoftData[];
}

export interface IcomItem {
  slot: number;
  title: string;
  src: string;
  curl: string;
  imptk: string[];
  clktk: string[];
  clstk: string[];
  desc: string;
  dj_softwareName: string;
  dj_softwareId: number;
  img: string;
  [key: string]: any;
}
export interface IComData {
  adspaces: {
    [key: string]: {
      ads: IcomItem[];
    };
  };
}

export interface IAppStatus {
  [propName: number]: number;
}

export interface IAppCleanStatus {
  [propName: number]: {
    stat: number;
    taskbar?: number;
    autorun?: number;
    plugins?: number;
  };
}

export interface IAppProgress {
  [propName: number]: {
    progress: number;
    speed: number;
    type: "download" | "install";
  };
}

export interface ISearchData extends ISoftData {
  logo: string;
  type_name: string;
  free: {
    flag: string;
    intro: string;
  };
  plugin: {
    flag: number;
    intro: string | null;
  };
  size: number;
  score: number;
  search_ext: ISoftConfig;
  search_view?: string[];
}

export interface ILoginData {
  userID: number;
  nickname: string;
  accountType: number; // 0:unkown 1:360账户 2:新浪微博账户 3:人人账户 4:邮件账户 5:飞信账户 6:微信账户
  cookie?: string;
  sex?: number;
  sign: string;
  isLogin: boolean;
  avatar?: string; // 从getUserHeadLocalImage接口返回
}

export enum IUserCenterNav {
  order = 0,
  mall = 1,
}
export interface IUserCenterInfo {
  level: string;
  score: string;
  checkInStatus: boolean;
  currentNav: IUserCenterNav;
}

export enum IOrderListNav {
  mall = 0,
  purchase = 1,
}

export enum IOrderTab {
  all = "all",
  underway = "underway",
  success = "success",
  fail = "fail",
}

export interface IOrderMall {
  ctime: string;
  order_id: string;
  qq?: string;
  tel?: string;
  logo: string;
  property: string;
  item_name: string;
  pay_channel: string;
  pay_amount: string;
  seller_id: string;
  status: number;
  status_desc: string;
  item_id: string;
  has_licence: number;
  need_info: {
    lic_email: string;
    [propName: string]: string;
  };
  show_reorder?: boolean;
}

export interface IOrderPurchase {
  soft_id: number;
  ctime: string;
  order_id: string;
  soft_name: string;
  product_cname: string;
  amount: number;
  pay_amount: number;
  status: string;
  code_name?: string;
  code_info?: string;
  ext?: string[];
}

export interface IOrderList {
  currentNav: IOrderListNav;
  mall: IOrderMall[];
  purchase?: IOrderPurchase[];
  mallTotal: number;
  mallStatusTotal: number;
  purchaseTotal?: number;
  mallPage?: number;
  purchasePage?: number;
  failOrder?: boolean;
  loadingList?: boolean;
  currentTab: IOrderTab;
}

export interface ICommentTag {
  tag_id: string;
  tag_name: string;
  times?: string;
}

export interface ISimilarSoft {
  soft_id: number;
  soft_name: string;
  soft_logo: string;
  soft_download_times: string;
  cate_name: string;
}
export interface IRelationSoft {
  soft_id: number;
  soft_alias_name: string;
  soft_logo?: string;
  soft_download_times?: string;
  cate_name?: string;
}

export enum ICommentType {
  all = "mesg",
  hot = "hot",
  best = "best",
  good = "good",
  bad = "bad",
}

export interface ISoftInfo {
  soft_id: number;
  soft_name: string;
  soft_baike_name: string;
  soft_score: number;
  edition_name: string;
  edition_version: string;
  edition_size: string;
  edition_pubtime: string;
  edition_brief: string;
  edition_free_plugin: string;
  edition_free: string;
  edition_plugin: string;
  edition_language: string;
  edition_runenv: string;
  edition_osbit: string;
  related_search_switch?: string;
  // edition_sale_flag?: "1" | "2";
  edition_contact_qq: {
    type?: "1" | "2";
    number: string;
  };
  soft_description: string;
  soft_sell_item_id?: string;
  soft_logo: {
    "32": string;
    "48": string;
    "72": string;
    "48_trans": string;
  };
  soft_iframe_url?: string;
  soft_snapshot: string[];
  // 前端默认对soft_config赋一个空对象
  soft_config: ISoftConfig & {
    detailimg?: string;
  };
  relation_soft_info: IRelationSoft[];
  // soft_sell_item_desc 售卖信息
  soft_sell_item_desc?: {
    soft_sell_item_id: string; //售卖id
    category: "1" | "2"; // 1 软件 | 2 会员
    desc: string;
    btn_text: string;
  };
  // 活动信息
  soft_activity_item_desc?: {
    soft_id?: number;
    open_type: OpenType;
    desc: string;
    href: string;
    exec: string;
    btn_text: string;
    starttime: string; // 活动开始时间 秒时间戳
    endtime: string; // 活动结束时间 秒时间戳
  };
}

export interface IPollsData {
  star: number[];
  poll_num: number;
  good_rate_f?: string;
  polls_tag?: ICommentTag[];
}

export interface ICommentCount {
  hot: number;
  mesg: number;
  best: number;
  good: number;
  bad: number;
}

export interface IComment {
  msgid: string;
  type: ICommentType;
  content: string;
  exp_level: number;
  create_time: string;
  agree: string;
  username: string;
  image_url: string;
  replys?: IComment[];
  replyid?: string;
  user_type?: "official" | "vendor";
  ext?: {
    sub_num: number;
  };
}

export interface IMyComment {
  content?: string;
  type?: ICommentType;
  tag_ids?: string[];
  tag_name?: string;
  msgid?: string;
  score?: number;
}

export interface IMallHotItem {
  icon: string;
  item_id: string;
  item_name: string;
  original_price: string;
  property: string;
  rank: string;
  sale_price: string;
  seller_id: string;
  show_discount: string;
  show_origin_price: string;
  sku_seller_id: string;
  text_tag?: string;
  show_tag?: string;
}

export interface IMallCell {
  img: string;
  item_id: string;
  property: string;
  from?: string;
}

export interface IMallNav {
  name: string;
  id: number;
}

export interface IMallBanner {
  box_list: IMallCell[];
  rotate_list: IMallCell[];
}

export interface IMallCategory {
  region_name: string;
  button_pic: string;
  img: string;
  link: string;
  style_type: string;
  uid: string;
  content: IMallCell[];
}

export interface IMallData {
  top_hot_list: IMallHotItem[];
  bottom_hot_list: IMallHotItem[];
  banner: IMallBanner;
  category: IMallCategory[];
  nav: IMallNav[];
  failOrder?: boolean;
}

export interface IMallAreaData {
  pic_url: string;
  list: Array<{
    cid: string;
    cname: string;
    items: IMallHotItem[];
  }>;
  nav: IMallNav[];
  failOrder?: boolean;
}

export interface IMallItemInfo {
  soft_id: number;
  item_id: string;
  item_name: string;
  pic_url: string;
  description: string;
  sale_text: string;
}

export interface IMallPrice {
  price: string;
  discount: string;
}
export interface IMallItem {
  discount: number;
  property: string;
  promotion_info: string;
  sale_price: string;
  seller_id: string;
  has_licence: number;
  original_price: string;
  stock_status: "1" | "2"; // 1 - 有库存， 2 - 无库存
  show_origin_price: string;
  need_info: {
    [propName: string]: {
      text: string;
      attr: {
        default_title: string;
      };
      limits: string[];
    };
  };
}

export interface IMallItems {
  item_info: IMallItemInfo;
  list: IMallItem[];
}

export interface IMallPay {
  listInfo: IMallItems[];
  selectItems: number[];
  currentNav?: number;
  showPay?: boolean;
  order_id?: string;
  submitResponse?: IMallSubmitResponse;
  startCount?: boolean;
  refresh?: boolean;
}

export interface INewMallPay {
  listInfo: ISPUItem[];
  selectItems: number[];
  currentNav?: number;
  showPay?: boolean;
  order_id?: string;
  submitResponse?: IMallNewSubmitResponse;
  startCount?: boolean;
  refresh?: boolean;
  account_tip?: string;
}

export interface IMallNewSubmitResponse {
  [key: string]: any;
}

export interface IMallSubmitResponse {
  alipay_img: string;
  discount_amount: number;
  order_id: string;
  price: string;
  product_name: string;
  property: string;
  weixin_img: string;
  account_tip: string;
  expire_time: number;
  [key: string]: any;
}

export enum IOrderStatus {
  underway = 1,
  success = 2,
  refunding = 3,
  refunded = 4,
  refundFailed = 5,
}

export enum INewOrderStatus {
  OrderStateWaitPay = 10, //待付款(初始状态)
  OrderStateWaitSendGoods = 20, //付款完成（待通知厂商）
  OrderStateWaitReceiveGoods = 30, //待厂商发权益（已通知厂商）
  OrderStateRefundApplying = 40, //售后中（厂商发起退款）
  OrderStateDone = 50, //交易完成（正常完成，厂商完成物品发放）
  OrderStateCancel = 60, //已取消（支付超时，过期等原因）
  OrderStateClose = 70, //交易关闭（退款完成）
}

export interface IMallOrder {
  soft_id: number;
  item_id: string;
  order_id: string;
  item_name: string;
  status: IOrderStatus;
  seller_id: string;
  has_licence: number;
  pay_amount: string;
  fail_desc: string;
  logo: string;
  activate_url: string;
  success_text?: string;
  licence?: {
    licence_ml?: string;
    licence?: string;
  };
  need_info: {
    [propName: string]: string;
  };
  account_tip: string;
  account_tips: Array<{
    name: string;
    value: string;
  }>;
}

export interface IMallNewOrder {
  bank_trade_code: string;
  mfr_create_time: string;
  mfr_order_amount: number;
  mfr_order_id: number;
  mfr_product_id: number;
  mfr_product_name: string;
  order_code: string;
  order_pay_time: string;
  order_refund_time: string;
  order_status: number;
  pay_chanel: number;
  fail_desc?: string;
  order_extra?: any
}

export interface IGameCell extends ISoftConfig {
  soft_id: number;
  [propName: string]: any;
}
export interface IGameData {
  banner: IGameCell[];
  top: IGameCell[];
  dataTop: IGameCell[];
  network: IGameCell[];
  standAlone: IGameCell[];
  pageGame: IGameCell[];
  hotList: IGameCell[];
  heatList: IGameCell[];
  advertising: IGameCell[];
}

export interface IRankCell extends ISoftConfig {
  soft_id: number;
  img: string;
  name: string;
}

export interface IRankList {
  board_id: string;
  board_name: string;
  list: Array<{
    soft_id: number;
    rankdiff: number;
    soft_name: string;
    score: string;
    size: number;
    logo: string;
    soft_download_times: string;
    soft_config?: ISoftConfig;
    clktk?: string[];
    imptk?: string[];
    category?: "1" | "2" | "3";
  }>;
}

export interface IRankData {
  banner: IRankCell[];
  hotlist: IRankCell[];
  ranklist: IRankList[];
}

export interface IGameAreaData {
  loading: boolean;
  banner: ISoftData[];
  searches: ISoftData[];
  hot: ISoftData[];
  recommend: ISoftData[];
  rank: ISoftData[];
}

export interface ShowIds {
  [key: string]: string[];
}

export interface ISKUItem {
  charge_type: number;
  deleted: number;
  ent_name: string;
  id: number;
  online_status: number;
  original_price: number;
  pay_succ_tips: string;
  present_price: number;
  qid: number;
  sku_desc: string;
  sku_id_external: string;
  sku_property_desc: string;
  sku_stock: number;
  spu_id: number;
}
export interface ISPUItem {
  account_enum: string;
  curr_status: number;
  id: number;
  soft_id: number;
  spu_combo_id: number;
  spu_desc: string;
  spu_icon: string;
  spu_id_third: string;
  spu_name: string;
  sku_info_list: ISKUItem[];
}
export interface IOPENAPI {
  errmsg: string;
  errno: number;
  time: number;
  data: ISPUItem[];
  trace_id: string;
}
